// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__ve6wT","activeLink":"Navigation_activeLink__41QJe Navigation_link__ve6wT","cartWrap":"Navigation_cartWrap__CMvne","text":"Navigation_text__kS8Yq"};